<template>
  <div
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div
      class="container-box"
      :style="{ background: theme.bgColor + ' url(' + ('https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/' + theme.bg) + ') no-repeat top center', }">
      <div>
        <div class="content-start" v-if="isPc? true: false">
          <el-tooltip content="切换主题" placement="right-start" effect="light">
            <div>
              <el-button :style="`background: ${theme.otherBgColor};color: #fff; font-size:18px;border: none;`" size="mini" @click="changeTheme">主题<i class="el-icon-magic-stick el-icon--right"></i></el-button>
            </div>
          </el-tooltip>
        </div>
        <section class="calcu-content">

          <div class="content-title">
            <el-image
              :src="`https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/${theme.titleBg}`"
            >
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
          </div>
          <div class="content-subhead">
            <el-image
              :src="`https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/${theme.subheadBg}`"
            >
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
          </div>
          <div class="content-table">
            <div class="innerBg">
              <img
                :src="`https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/${theme.lableBg}`"
              />
            </div>
            <div class="innerBg-box"></div>

            <div class="tab-box">
              <div class="selection-area">
                <div v-for="item in activeTab" @click="changeTab(item.active)">
                  <div
                    v-if="item.show"
                    class="sel-tab long-sel-tab"
                    :style="{ background: 'url(' + require('./../assets/' + theme.tabbt) + ') no-repeat 0 0/100% 100%', }"
                  >
                    <span><span>{{ item.title }}</span><span v-if="isPc">{{ item.titleS }}{{ item.titleF }}</span></span>

                    <span v-if="!isPc">{{ item.titleS }}</span>
                    <span v-if="!isPc">{{ item.titleF }}</span>
                    <i class="add-tips">{{ item.tip }}</i>
                  </div>
                  <div
                    v-else
                    class="sel-tab long-sel-tab"
                    :style="{ background: 'url(' + require('./../assets/greytabbt.png') + ') no-repeat 0 0/100% 100%', }"
                  >
                    <span><span>{{ item.title }}</span><span v-if="isPc">{{ item.titleS }}{{ item.titleF }}</span></span>

                    <span v-if="!isPc">{{ item.titleS }}</span>
                    <span v-if="!isPc">{{ item.titleF }}</span>
                    <i class="add-tips">{{ item.tip }}</i>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-box">
              <div class="table">
                <div class="sel-header" :style="{ background: theme.themeColor }">
                  <div class="sel-tips">
                    {{ nowActive.title }}{{ nowActive.titleS }}{{ nowActive.titleF }}{{ nowActive.tip }}
                    <div
                      v-if="nowActive.active == 1 ? true : false"
                      class="tips-top"
                    >
                      <span class="top-link" @click="openIframe(1)">总数Top10</span>
                      <span class="top-link" @click="openIframe(2)">全国企业Top10</span>
                      <span class="top-link" @click="worldCollect" >全国企业</span>
                      <span class="top-link" @click="openIframe(3)" >全国学校Top10</span>
                      <span class="top-link" @click="educationCollect" >全国学校</span>
                      <span class="top-link" @click="cityCollect" >城市Top100</span>
                      <!-- <span class="top-link" @click="showCodeDialog" >推荐码</span> -->
                    </div>
                    <div
                      v-if="nowActive.active == 2 ? true : false"
                      class="tips-top"
                    >
                      <span class="top-link" @click="areaCityCollect" >城市排名</span>
                    </div>
                    <div class="update-time" v-if="isPc">
                      数据统计截止到 <span v-if="updateTime">{{updateTime}}</span>
                    </div>
                  </div>
                </div>
                <!-- 筛选工具栏 -->
                <el-row :gutter="10">
                  <div style="text-align:right;margin-top:5px;margin-right:10px;" v-if="!isPc">
                  数据统计截止到 <span v-if="updateTime">{{updateTime}}</span>
                  </div>
                  <div v-if="nowActive.active == 8" class="tabs-box tabs-box-3">
                    <el-row :gutter="10">
                      <el-col :span = "24">
                        <el-tabs :class="theme.tabsBg"
                          type="card" style="width: 100%;"
                          v-model="volunteerActiveName"
                          @tab-click="changeVolunteerTabelTab">
                          <el-tab-pane label="网安联志愿服务站" name="first">
                          </el-tab-pane>
                          <el-tab-pane label="网安联志愿服务队" name="second">
                          </el-tab-pane>
                          <el-tab-pane label="志愿者" name="three">
                          </el-tab-pane>
                        </el-tabs>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-if="nowActive.active == 2" class="tabs-box tabs-box-2 tabs-row-2">
                    <el-row :gutter="10">
                      <el-col :span = "24">
                        <el-tabs :class="theme.tabsBg"
                          type="card" style="width: 100%;"
                          v-model="areaActiveName"
                          @tab-click="changeAreaTabelTab">
                          <el-tab-pane name="first">
                            <div slot="label">
                              <div style="line-height: 30px;">网络诚信建设专题采集量</div>
                              <div style="font-size: 12px;line-height: 15px">（汇总统计）</div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane name="second">
                            <div slot="label">
                              <div style="line-height: 30px;">主问卷/专题问卷采集量</div>
                              <div style="font-size: 12px;line-height: 15px">（数量汇总）</div>
                            </div>
                          </el-tab-pane>
                        </el-tabs>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-if="nowActive.active == 5" class="tabs-box tabs-box-2">
                    <el-row :gutter="10">
                      <el-col :span = "24">
                        <el-tabs :class="theme.tabsBg"
                          type="card" style="width: 100%;"
                          v-model="unitActiveName"
                          @tab-click="changeUnitTabelTab">
                          <el-tab-pane label="发起单位" name="first">
                          </el-tab-pane>
                          <el-tab-pane label="推荐单位" name="second">
                          </el-tab-pane>
                        </el-tabs>
                      </el-col>
                    </el-row>
                  </div>
                  <!-- 1:省市2:区域5:发起单位 6:各链接 -->
                  <div
                    :class="(nowActive.active == 1 || nowActive.active == 2)? 'tool-bar end-tool-bar' : 'tool-bar'"
                  >
                    <el-col :span="isPc? 6:12 " v-show="nowActive.active == 5">
                      <div class="tool-input">
                        <el-input
                          :placeholder="unitActiveName === 'second'? '请输入推荐单位': '请输入发起单位'"
                          v-model="toolData.recommended"
                          clearable
                        >
                        </el-input>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 6: 12 "
                      v-show="nowActive.active == 5">
                      <el-button
                        @click="searchEvent"
                        plain
                      >搜索</el-button>
                      <el-button
                        @click="exportData"
                        plain
                        >导出</el-button
                      >
                    </el-col>
                    <!-- 服务站,服务队 -->
                    <template v-if="nowActive.active == 8 && (volunteerActiveName === 'first' || volunteerActiveName === 'second') && !showMap">
                      <el-col :span="isPc? 6 : 12 ">
                        <div class="tool-input">
                          <el-input
                            placeholder="请输入来源关键字搜索"
                            v-model="toolData.volunteerOrgName"
                            clearable
                          >
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="isPc? 6 : 12 ">
                        <el-button
                          @click="searchEvent"
                          plain
                          >搜索</el-button
                        >
                        <el-button
                          @click="mapEvent"
                          plain
                        >地图统计</el-button>
                        <el-button
                          v-show="isPc && volunteerActiveName === 'first'"
                          @click="exportData"
                          plain
                          >导出</el-button
                        >
                      </el-col>

                    </template>
                    <template v-if="nowActive.active == 8 && (volunteerActiveName === 'first' || volunteerActiveName === 'second') && showMap">
                      <el-col :span="isPc? 24 : 24 ">
                        <div style="text-align:right;display: flex; justify-content: flex-end;">
                          <el-button
                            @click="tableEvent"
                            plain
                            >表格统计</el-button>
                        </div>
                      </el-col>
                    </template>

                    <!-- 志愿者 -->
                    <template v-if="nowActive.active == 8 && volunteerActiveName === 'three'">
                      <el-col :span="isPc? 6 : 18 ">
                        <div class="tool-input">
                          <el-input
                            placeholder="请输入来源关键字搜索"
                            v-model="toolData.sourceName"
                            clearable
                          >
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="isPc? 4 : 6 ">
                        <el-button
                          @click="searchEvent"
                          plain
                          >搜索</el-button>
                      </el-col>
                    </template>

                    <el-col :span="isPc? 5 : 8 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >
                        <el-select
                          v-model="toolData.province"
                          @change="changeProvince"
                          filterable
                          clearable
                          placeholder="请选择省"
                        >
                          <el-option
                            v-for="item in provinceList"
                            :key="item.province"
                            :label="item.province"
                            :value="item.province"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 5 : 8 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >
                        <el-select
                          v-model="toolData.city"
                          filterable
                          clearable
                          placeholder="请选择市"
                        >
                          <el-option
                            v-for="item in cityList"
                            :key="item.city"
                            :label="item.city"
                            :value="item.city"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 5 : 8 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >
                        <el-select
                          v-model="toolData.category"
                          filterable
                          clearable
                          placeholder="请选择分类"
                        >
                          <el-option
                            v-for="item in sortList"
                            :key="item.id"
                            :label="item.categoryName"
                            :value="item.categoryName"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 5 : 12 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >
                        <el-input
                          placeholder="请输入来源名称或ID"
                          v-model="toolData.sourceName"
                          clearable
                        >
                        </el-input>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 4 : 12 "
                      v-show="nowActive.active == 6">
                      <el-button
                        @click="searchEvent"
                        plain
                        >搜索</el-button
                      >
                      <el-button
                        @click="exportData"
                        plain
                        >导出</el-button
                      >
                    </el-col>
                    <el-col :span="24"
                      v-show="(nowActive.active == 1 || nowActive.active == 2) && !showMap">
                      <div style="display: flex;justify-content: end;">
                        <el-button
                          @click="mapEvent"
                          plain
                        >地图统计</el-button>
                        <el-button
                          @click="exportData"
                          v-show="nowActive.active == 1 || (nowActive.active == 2 && areaActiveName === 'first')"
                          plain
                        >导出</el-button>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 3 : 8 "
                      v-show="(nowActive.active == 1 || nowActive.active == 2) && showMap">
                      <el-button
                        @click="tableEvent"
                        plain
                        >表格统计</el-button>
                    </el-col>
                  </div>
                </el-row>
                <div class="caculate-area">
                  <div class="data-scroll-area">
                    <!-- 参与答题网名区域分布:2和各省市实际采集量:1表格 -->
                    <div class="total-table">
                      <el-table
                        v-show="nowActive.active == 1 &&!showMap"
                        v-loading="tableDataLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :summary-method="getSummariesZG"
                        show-summary
                        :data="provincesAndCitiesData"
                        :max-height="isPc?screenHeight-50:'90000'"
                        style="width:100%;"
                        :header-cell-style="{background:'#F2F4F5'}"
                        row-key="id"
                        stripe
                        :fit="true"
                        ref="table"
                        fixed
                        :tree-props="{ children: 'sublist' }"
                        :border="isPc?false:true"
                        :header-row-style="{height: '48px'}"
                      >
                        <el-table-column label="序号" :width="isPc?'80':'50'" align="right">
                           <template slot-scope="scope">
                            <span>{{ scope.row.id | filterIdS }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="区域" width="" align="center">
                          <template slot-scope="scope">
                            <span v-if="!!scope.row.isClick && (!!scope.row.district || !!scope.row.city || scope.row.city ==='广州市')"
                              @click="clickRecommend(scope.row, scope.$index)"
                              :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                            >
                              {{ scope.row.name }}
                            </span>
                            <span v-else
                            >
                              {{ scope.row.name }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="amount" label="总数量" width="" align="center">
                          <template slot-scope="scope">
                            <span>
                              {{ scope.row.amount }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="percentDesc" label="总占比" width="" align="center">
                        </el-table-column>
                        <!-- <el-table-column prop="publicAmount" label="公众数量" :min-width="isPc?'':'27%'" align="center">
                        </el-table-column>
                        <el-table-column prop="employmentAmount" label="从业数量" :min-width="isPc?'':'27%'" align="center">
                        </el-table-column> -->
                      </el-table>
                    </div>
                    <div class="total-table-2 total-table-3" style="overflow-x: auto;">
                      <el-table
                        v-show="(nowActive.active == 2 && areaActiveName==='first') &&!showMap"
                        v-loading="tableDataAreaLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="totalAreaData"
                        :max-height="isPc?screenHeight-50:'90000'"
                        style="width:100%;"
                        :header-cell-style="{background:'#F2F4F5'}"
                        row-key="id"
                        stripe
                        :fit="true"
                        ref="area"
                        :tree-props="{ children: 'sublist' }"
                        :border="isPc?false:true"
                        :row-class-name="tableRowClassName"
                        header-align="center"
                      >
                        <el-table-column label="序号" :width="isPc?'80':'30'" :align="isPc?'center':'right'">
                          <template slot-scope="scope">
                            <span>{{ scope.row.id | filterIdS }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="区域" :width="isPc?'':'28'" align="center">
                          <template slot-scope="scope">
                            <span v-if="!!scope.row.isClick && (!!scope.row.district || !!scope.row.city || scope.row.city ==='广州市')"
                              @click="clickRecommend(scope.row, scope.$index)"
                              :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                            >
                              {{ scope.row.name }}
                            </span>
                            <span v-else
                            >
                              {{ scope.row.name }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column :label="isPc?'第二阶段样本量\n(10.19-11.7)':'第二阶段\n样本量\n(10.19-11.7)'" align="center">
                          <el-table-column label="数量" align="center" :min-width="isPc?'':'20%'">
                            <template slot-scope="scope">
                              <span>
                                {{ scope.row.secondStageAmount }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="secondStagePercentDesc" label="占比 " align="center" :width="isPc?'':'44'">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column :label="isPc?'第一阶段样本量\n(9.13-22)':'第一阶段\n样本量\n(9.13-22)'" align="center">
                          <el-table-column label="数量" align="center" :min-width="isPc?'':'20%'">
                            <template slot-scope="scope">
                              <span>
                                {{ scope.row.firstStageAmount }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="firstStagePercentDesc" label="占比 " align="center" :width="isPc?'':'44'">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column label="总样本量" align="center">
                          <el-table-column label="数量" align="center" :min-width="isPc?'':'20%'">
                            <template slot-scope="scope">
                              <span>
                                {{ scope.row.stageAmount }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="stagePercentDesc" label="占比 " align="center" :width="isPc?'':'44'">
                          </el-table-column>
                        </el-table-column>

                        <!-- <el-table-column prop="amount" label="主问卷总量 " align="center" :min-width="isPc?'':'21%'">
                        </el-table-column>
                        <el-table-column v-if="isPc" prop="percentDesc" label="总占比 " align="center" width="">
                        </el-table-column> -->
                        <!-- <el-table-column prop="publicAmount" label="公众主问卷合计" align="center" :min-width="isPc?'':'21%'">
                        </el-table-column>
                        <el-table-column prop="employmentAmount" label="从业主问卷合计" align="center" :min-width="isPc?'':'20%'">
                        </el-table-column> -->
                        <!-- <el-table-column prop="specialAmount" label="专题问卷总量" align="center" :min-width="isPc?'':'21%'">
                        </el-table-column> -->
                      </el-table>
                    </div>
                    <div v-show="showMap">
                      <div
                        id="mapContainer"
                        class="calDataShow mapDivisionData"
                        :style="isPc?'width:100%;height:1100px;':'width:700px;height: 700px;'"
                      ></div>
                    </div>
                    <!-- subject主问卷/专题采集量 （数量汇总） -->
                    <div class="total-table-2 total-table-3" style="overflow-x: auto;">
                      <el-table
                        v-show="(nowActive.active == 2 && areaActiveName==='second') &&!showMap"
                        v-loading="subjectLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="subjectTableData"
                        style="width:100%;border: 2px solid #ebeef5;"
                        :header-cell-style="{background:'#F2F4F5'}"
                        row-key="id"
                        stripe
                        :fit="true"
                        ref="subject"
                        :tree-props="{ children: 'sublist' }"
                        :border="true"
                        :row-class-name="tableRowClassName"
                      >
                        <el-table-column label="序号" :width="isPc?'60':'35'" align="right" fixed="left">
                          <template slot-scope="scope">
                            <span>{{ scope.row.id | filterId }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="所属区域" width="68" align="center" fixed="left">
                          <template slot-scope="scope">
                            <span v-if="!!scope.row.isClick && (!!scope.row.city || scope.row.city ==='广州市')"
                              @click="clickRecommend(scope.row, scope.$index)"
                              :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                            >
                              {{ scope.row.name }}
                            </span>
                            <span v-else
                            >
                              {{ scope.row.name }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column label="合计" prop="totalAmount" width="65" align="center">
                        </el-table-column>
                        <el-table-column label="网民答题(主间卷、专题)数量汇总" align="center">
                          <el-table-column :label="'主问卷'" prop="amount" width="65" align="center">
                          </el-table-column>
                          <el-table-column label="1.法治社会建设" prop="publicSpecial1Amount" width="" align="center">
                          </el-table-column>
                          <el-table-column label="2.网络诚信建设" prop="publicSpecial2Amount" width="" align="center">
                          </el-table-column>
                          <el-table-column label="3.遏制惩处网络违法犯罪" prop="publicSpecial3Amount" width="" align="center">
                          </el-table-column>
                          <el-table-column label="4.个人信息保护和数据安全" prop="publicSpecial4Amount" width="" align="center">
                          </el-table-column>
                          <el-table-column label="5.网络购物安全权益保护" prop="publicSpecial5Amount" width="" align="center">
                          </el-table-column>
                          <el-table-column label="6.特殊人群网络权益保护" prop="publicSpecial6Amount" width="" align="center">
                          </el-table-column>
                          <el-table-column label="7.互联网平台监管与企业自律" prop="publicSpecial7Amount" width="" align="center">
                          </el-table-column>
                          <el-table-column label="8.数字政府服务与治理能力提升" prop="publicSpecial8Amount" width="" align="center">
                          </el-table-column>
                          <el-table-column label="9.数字经济发展和网络安全挑战" prop="publicSpecial9Amount" width="" align="center">
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- 发起、推荐单位采集量 -->
                    <div class="total-table">
                      <el-table
                        v-show="nowActive.active == 5"
                        v-loading="recommendTableDataLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :ref="unitActiveName === 'second'?'recommended':'initiate'"
                        :data="unitActiveName === 'second'? recommendTableData: initiateTableData"
                        :summary-method="getSummaries"
                        show-summary
                        :max-height="isPc?screenHeight-50:'90000'"
                        style="width: 100%"
                        stripe
                        :fit="true"
                        :header-cell-style="{background:'#F2F4F5'}"
                        :border="isPc?false:true"
                        :header-row-style="{height: '48px'}"
                      >
                        <el-table-column label="序号" :width="isPc?'80':'35'" align="center">
                          <template slot-scope="scope">
                            <span>{{ scope.row.id }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column :label="unitActiveName === 'second'? '推荐单位': '发起单位'" :min-width="isPc?'230':'14%'" align="center">
                          <template slot-scope="scope">
                            <div
                              v-if="scope.row.name !== '组委会'"
                              @click="clickRecommend(scope.row, scope.$index)"
                              :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                            >
                              {{ scope.row.name }}
                            </div>
                            <div v-else>
                              {{ scope.row.name }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="amount" label="总数量" :min-width="isPc?'':'13%'" align="center">
                        </el-table-column>
                        <el-table-column prop="percentDesc" label="总占比" :width="isPc?'':'80'" align="center">
                        </el-table-column>
                        <!-- <el-table-column prop="publicAmount" label="公众数量" :min-width="isPc?'':'13%'" align="center">
                        </el-table-column>
                        <el-table-column prop="employmentAmount" label="从业数量" :min-width="isPc?'':'13%'" align="center">
                        </el-table-column> -->
                      </el-table>
                    </div>
                    <!-- 各链接采集量 -->
                    <div class="total-table-2 total-table-3" style="overflow-x: auto;" v-show="nowActive.active == 6">
                      <el-row :gutter="10">
                        <el-col :span = "24">
                          <el-table
                            ref="thePublic"
                            v-loading="thePublicLoading"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                            :data="collectBaseList"
                            :header-cell-style="{background:'#F2F4F5'}"
                            key="thePublic"
                            style="width: 100%;"
                            stripe
                            fixed
                            :border="isPc?false:true"
                            :row-class-name="tableRowClassName"
                          >
                            <el-table-column label="序号" :width="isPc?'60':'35'" align="center">
                              <template slot-scope="scope">
                                <span>{{ scope.row.id }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column prop="province" label="区域" :width="isPc?'':'40'" align="center">
                            </el-table-column>
                            <el-table-column prop="city" label="市" :width="isPc?'':'40'" align="center">
                            </el-table-column>
                            <el-table-column v-if="isPc" prop="category" label="分类" :width="isPc?'':'55'" align="center">
                            </el-table-column>
                            <el-table-column prop="" :label="isPc?'来源渠道(ID)':'来源渠道\n(ID)'"  :min-width="isPc?'180':'20%'" align="center">
                              <template slot-scope="scope">
                                <div>
                                  {{ scope.row.sourceStr }}
                                </div>
                              </template>
                            </el-table-column>
                            <el-table-column prop="publicSpecial2Amount" :label="isPc?'网络诚信建设\n专题数量':'网络诚\n信建设\n专题数量'" :width="isPc?'':'50'" align="center">
                            </el-table-column>
                            <el-table-column prop="" :label="isPc?'主问卷数量':'主问卷\n数量'" :width="isPc?'':'42'" align="center">
                              <template slot-scope="scope">
                                <div>
                                  {{ scope.row.amount }}
                                </div>
                              </template>
                            </el-table-column>
                            <el-table-column prop="" :label="isPc?'其他专题数量':'其他专题\n数量'" :width="isPc?'':'50'" align="center">
                              <template slot-scope="scope">
                                <div>
                                  {{ scope.row.totalAmount-scope.row.publicSpecial2Amount-scope.row.amount }}
                                </div>
                              </template>
                            </el-table-column>
                            <el-table-column prop="totalAmount" :label="isPc?'总样本数量':'总样本\n数量'" :width="isPc?'':'45'" align="center">
                            </el-table-column>
                          </el-table>
                        </el-col>
                      </el-row>
                    </div>
                    <!-- 志愿服务 -->
                    <div class="total-table" v-show="nowActive.active == 8 && ((!showMap && volunteerActiveName!=='three') || volunteerActiveName==='three')">
                      <el-row :gutter="10">
                        <el-col :span = "24">
                          <el-table
                            v-loading="volunteerLoading"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                            :ref="volunteerActiveName === 'second'?'team':(volunteerActiveName === 'three'?'volunteer':'agency')"
                            :summary-method="getSummaries"
                            show-summary
                            :data="volunteerActiveName === 'second'? volunteerTeamTableData: (volunteerActiveName === 'three'? volunteerTableData: volunteerAgencyTableData)"
                            :header-cell-style="{background:'#F2F4F5'}"
                            row-key="id"
                            stripe
                            :max-height="isPc?screenHeight-50:'90000'"
                            style="width:100%;"
                            :tree-props="{ children: 'sublist' }"
                            :border="isPc?false:true"
                            :header-row-style="{height: '48px'}"
                          >
                            <el-table-column label="序号" :width="isPc?'80':'38'"  :align="volunteerActiveName === 'first'?'right':'center'">
                              <template slot-scope="scope">
                                <span>{{ scope.row.id | filterId }}</span>
                              </template>
                            </el-table-column>
                            <!-- <el-table-column v-if="volunteerActiveName !== 'three'" label="省" :width="isPc?'60':'35'" align="center">
                              <template slot-scope="scope">
                                <div>{{ scope.row.province }}</div>
                              </template>
                            </el-table-column>
                            <el-table-column v-if="volunteerActiveName !== 'three'" label="市" :width="isPc?'60':'40'" align="center">
                              <template slot-scope="scope">
                                <div>{{ scope.row.city }}</div>
                              </template>
                            </el-table-column> -->
                            <el-table-column :label="volunteerActiveName === 'second'?'志愿服务队':(volunteerActiveName === 'three'?'志愿者':'志愿服务站')" width="" align="center">
                              <template slot-scope="scope">
                                <div
                                  v-if="!!scope.row.isClick && (!!scope.row.volunteerUnitName || !!scope.row.volunteerOrgName)"
                                  @click="clickRecommend(scope.row, scope.$index)"
                                  :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                                >
                                  {{ scope.row.name }}
                                </div>
                                <div v-else>{{ scope.row.name }}</div>
                              </template>
                            </el-table-column>
                            <el-table-column prop="amount" label="总数量" :width="isPc?'':'50'" align="center">
                            </el-table-column>
                            <el-table-column prop="percentDesc" label="总占比" :width="isPc?'':'50'" align="center">
                            </el-table-column>
                            <!-- <el-table-column prop="publicAmount" label="公众数量" :min-width="isPc?'':'13%'" align="center">
                            </el-table-column>
                            <el-table-column prop="employmentAmount" label="从业数量" :min-width="isPc?'':'13%'" align="center">
                            </el-table-column> -->
                            <el-table-column label="操作" width="" align="center" prop="">
                              <template slot-scope="scope">
                                <el-button v-if="scope.row.amount>50" @click="createPlacard(scope.row, scope.$index)" type="primary" size="mini">生成喜报</el-button>
                                <el-button v-else  type="info" disabled size="mini">生成喜报</el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                        </el-col>
                      </el-row>
                    </div>
                    <!-- 推荐码 -->

                    <el-table
                      v-show="nowActive.active == 9"
                      v-loading="referralTableDataLoading"
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      :data="referralTableData"
                      show-summary
                      :max-height="isPc?screenHeight-50:'90000'"
                      style="width: 100%;"
											:header-cell-style="{background:'#F2F4F5'}"
                      stripe
                      fixed
                      :summary-method="getSummariesReferral"
                      row-key="sourceName"
											center
                      :tree-props="{ children: 'childrenList' }"
                      :border="isPc?false:true"
                      :header-row-style="{height: '48px'}"
                    >
                      <el-table-column label="序号" :width="isPc?'120':'38'" align="left">
                        <template slot-scope="scope">
                          <span>{{ isPc?scope.row.id:' ' }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="来源渠道" :width="isPc?'230':''" align="center">
                        <template slot-scope="scope">
                          <div>
                            {{ scope.row.sourceName }}
                          </div>
                        </template>
                      </el-table-column>
                      <!-- <el-table-column prop="publicAmount" label="公众网民数量" :width="isPc?'':'50'" align="center">
                      </el-table-column>
                      <el-table-column prop="employmentAmount" label="从业人员数量" :width="isPc?'':'50'" align="center">
                      </el-table-column> -->
                      <el-table-column prop="amount" label="总数量" :width="isPc?'':'80'" align="center">
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <el-dialog
      :title="dialogRecommendTitle"
      :visible.sync="dialogRecommendTable"
      center
      :width="isPc?'80%':'95%'"
      class="dialog-container"
      top="5vh"
    >
      <div v-if="nowActive.active == 5" style="display: flex;justify-content: flex-end; padding-bottom: 10px;">
        <el-button
          @click="exportSourceData(dialogRecommendTitle, unitActiveName)"
          plain
        >导出</el-button>
      </div>
      <div class="dialog-box total-table-2">
        <el-table
          v-loading="dialogRecommendLoading"
          :data="dialogRecommendData"
					:header-cell-style="{background:'#F2F4F5'}"
          :height="screenHeight-100"
          stripe
          :row-class-name="tableRowClassName"
          header-align="center"
        >
          <el-table-column type="index" label="序号" :width="isPc?'100':'35'" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="省" :width="isPc?'':'35'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.province }} </div>
            </template>
					</el-table-column>
          <el-table-column label="城市" :width="isPc?'':'40'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.city }} </div>
            </template>
					</el-table-column>
          <el-table-column prop="category" label="分类" :width="isPc?'':'40'" align="center"> </el-table-column>
          <el-table-column label="来源渠道" :min-width="isPc?'250':'20%'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.sourceName }}
                <span v-if="(nowActive.active == 5 || nowActive.active == 8) && (scope.row.sourceName!=='' && scope.row.sourceName !=='合计')">({{ scope.row.sourceId }})</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="总数" :min-width="isPc?'':'15%'" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.amount }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="publicAmount" label="公众" :min-width="isPc?'':'15%'" align="center"> </el-table-column>
          <el-table-column prop="employmentAmount" label="从业" :min-width="isPc?'':'15%'" align="center"> </el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
    <!-- dialogcityTopLoading 城市top100 -->
    <el-dialog
      title="城市Top100"
      :visible.sync="dialogcityTop"
      center
      :width="isPc?'80%':'95%'"
      class="dialog-container"
      top="5vh"
    >
      <div class="dialog-box">
        <el-table
          v-loading="dialogcityTopLoading"
          :data="cityTableDataTop100"
					:header-cell-style="{background:'#F2F4F5'}"
          :height="screenHeight-100"
          stripe
        >
        <!-- 序号，城市，所属省，总数，公众，从业 -->
          <el-table-column type="index" label="序号" :width="isPc?'100':'35'" align="center">
          </el-table-column>
          <el-table-column label="城市" :min-width="isPc?'':'20%'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.city }} </div>
            </template>
					</el-table-column>
          <el-table-column label="所属省" :min-width="isPc?'':'20%'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.province }} </div>
            </template>
					</el-table-column>
          <el-table-column label="总数" :min-width="isPc?'':'20%'" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.amount }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="publicAmount" label="公众" :min-width="isPc?'':'20%'" align="center"> </el-table-column>
          <el-table-column prop="employmentAmount" label="从业" :min-width="isPc?'':'20%'" align="center"> </el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      title="城市排名（包含第一阶段，第二阶段）"
      :visible.sync="dialogAreaCityTop"
      center
      :width="isPc?'80%':'95%'"
      class="dialog-container"
      top="5vh"
    >
      <div class="dialog-box">
        <el-table
          v-loading="dialogAreaCityTopLoading"
          :data="areaCityTableData"
					:header-cell-style="{background:'#F2F4F5'}"
          :height="screenHeight-100"
          stripe
        >
        <!-- 序号，城市，所属省，总数，公众，从业 -->
          <el-table-column type="index" label="序号" :width="isPc?'100':'35'" align="center">
          </el-table-column>
          <el-table-column label="城市" :min-width="isPc?'':'20%'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.city }} </div>
            </template>
					</el-table-column>
          <el-table-column label="所属省" :min-width="isPc?'':'20%'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.province }} </div>
            </template>
					</el-table-column>
          <el-table-column label="总数" :min-width="isPc?'':'20%'" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.totalAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="占比" :min-width="isPc?'':'20%'" align="center">
            <template slot-scope="scope">
              <div>{{ (scope.row.totalAmount/totalAreaData[0].totalAmount*100).toFixed(2) }}%</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="publicAmount" label="公众" :min-width="isPc?'':'20%'" align="center"> </el-table-column>
          <el-table-column prop="employmentAmount" label="从业" :min-width="isPc?'':'20%'" align="center"> </el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
		<el-dialog
      :visible.sync="showIframe"
      center
			:width="isPc?'450px':'100%'"
      top="5vh"
    >
			<div v-if="showIframe && showWorldTop" class="iframe-box">
        <my-top :dataList="provincesAndCitiesTop" :time="updateTime"></my-top>
			</div>
      <div v-if="showIframe && showFirmTop" class="iframe-box">
        <firm-top :dataList="companyTop" :time="updateTime"></firm-top>
			</div>
      <div v-if="showIframe && showEducationTop" class="iframe-box">
        <education-top :dataList="educationTop" :time="updateTime"></education-top>
			</div>
		</el-dialog>
    <!--   showCodeDia -->
    <el-dialog
      title="推荐码"
      :visible.sync="showCodeDia"
      center
			:width="isPc?'80%':'100%'"
      class="dialog-container"
    >
      <div style="width: 100%; display: flex;justify-content: center;margin-bottom: 10px; ">
        <div :style="isPc?'width: 20%; margin-right: 1%;':'width: 38%; margin-right: 2%;'">
          <el-input
            :placeholder="isPc?'请输入推荐码':'推荐码'"
            v-model="toolData.sourceId"
            clearable
          >
          </el-input>
        </div>
        <div :style="isPc?'width: 20%; margin-right: 1%;':'width: 38%; margin-right: 2%;'">
          <el-input
            :placeholder="isPc?'请输入来源':'来源'"
            v-model="toolData.sourceName"
            clearable
          >
          </el-input>
        </div>
        <el-button
          @click="searchCodeEvent"
          plain
        >搜索</el-button>
      </div>
			<el-table
        v-loading="referralTableDataLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :data="referralTableData"
        show-summary
        :height="isPc?'500':'600'"
        style="width: 100%"
        :header-cell-style="{background:'#F2F4F5'}"
        stripe
        fixed
        :summary-method="getSummariesReferral"
        row-key="sourceName"
        center
        :tree-props="{ children: 'childrenList' }"
        :border="isPc?false:true"
        :header-row-style="{height: '48px'}"
      >
        <el-table-column label="序号" :width="isPc?'80':'45'" align="center">
          <template slot-scope="scope">
            <span>{{ isPc?scope.row.id:' ' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="来源渠道" :width="isPc?'':''" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.sourceName }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="publicAmount" label="公众网民数量" :width="isPc?'':'65'" align="center">
        </el-table-column>
        <el-table-column prop="employmentAmount" label="从业人员数量" :width="isPc?'':'65'" align="center">
        </el-table-column> -->
        <el-table-column prop="amount" label="总数量" :width="isPc?'':'65'" align="center">
        </el-table-column>
      </el-table>
		</el-dialog>
    <el-dialog
      :visible.sync="showPlacard"
      title="喜报"
      center
      :width="isPc?'600px':'100%'"
      class="dialog-container"
    >
      <div style="display:flex; flex-direction: column; align-items: center; justify-content:center;">
        <div ref="poster" id="poster" class="poster">
          <!-- 背景图 -->
          <img :src="backgroundImage" alt="Background" class="background-image">

          <!-- 文字 -->
          <div class="poster-text">
            <div class="text-1">
              截至{{ placardObj.time }}
            </div>
            <div class="text-2">
              <div>
                {{ placardObj.name }}
              </div>
            </div>
            <div class="text-3">
              突破{{ placardObj.amount }}<span>份</span>
            </div>
          </div>
        </div>
        <div style="margin-top:20px;">
          <el-button
            v-if="isPc"
            type="primary"
            @click="generatePoster"
          >
            保存本地
          </el-button>
          <el-button
            v-else
            type="primary"
            @click="openImg"
          >
            保存本地
          </el-button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import axios from 'axios'
import * as echarts from 'echarts'
import geojson from './geojson.json' // 无省市后缀
import XLSX from 'xlsx'
// import geojson from './china.json' // 有省市后缀
import MyTop from './top.vue';
import FirmTop from './firmTop.vue';
import EducationTop from './educationTop.vue';

// 创建一个axios实例
const apiInstance = axios.create({
  // baseURL: 'https://myd.iscn.org.cn',
  baseURL: 'https://myd-api.iscn.org.cn',
  // headers: {
  //   'Content-Type': 'application/json'
  // },
});
var myChart;
export default {
  name: 'Home',
  components: {
    'my-top': MyTop,
    'firm-top': FirmTop,
    'education-top': EducationTop
  },
  data() {
    return {
      placardObj: {
        amount: 0,
        name: "",
        time: ""
      },
      // 背景图 URL
      backgroundImage: 'https://survey.iscn.org.cn/tduck-cloud/miniAppFile/c460948743404d49a5497d7a0bc4c6b9.jpg',
      // 海报文字
      posterText: 'Your Poster Text',
      showPlacard: false,
      formKey: "1QlHbWVJ",
      publicFormKey: "S8Xy1gxC", // 正式
      employmentFormKey: 'nFmRfbow', // 正式
      geojsonData: {},
      theme: {
        isRed: false,
        bg: 'bg2023_special2.png',
        themeColor: "#1DCBFD",
        bgColor: "#D3F5FB",
        titleBg: 'title2023_2.png',
        subheadBg: 'subhead2023_special2.png',
        lableBg: 'lable2023_2.png',
        tabbt: 'tabbt2023_2.png',
        otherBgColor: "#F77768",
        tabsBg: 'custom-tabs-no-red',
        textColor: 'blue'
      },
      year: 2023,
      activeTab: [
        {
          active: 6,
          title: "各链接",
          titleS: "",
          titleF: "采集量",
          tip: " ",
          show: true
        },{
          active: 1,
          title: "各省市实际",
          titleS: "",
          titleF: "采集量",
          tip: " (汇总统计)",
          show: false
        },
        {
          active: 2,
          title: "参与答题网民",
          titleS: "",
          titleF: "区域分布",
          tip: " (汇总统计)",
          show: false
        },
        {
          active: 5,
          title: "发起单位",
          titleS: "(推荐单位)",
          titleF: "采集量",
          tip: " ",
          show: false
        },
        {
          active: 8,
          title: "志愿服务",
          titleS: "",
          titleF: "",
          tip: " ",
          show: false
        },
        // {
        //   active: 9,
        //   title: "推荐码",
        //   tip: " ",
        //   show: false
        // }
      ],
      nowActive: {
        active: 6,
        title: "各链接",
        titleS: "",
        titleF: "采集量",
        tip: " ",
        show: true
      },
			tableKey: 2,
      totalAreaData: [], //参与答题网民区域分布
      provincesAndCitiesData: [], // 各省市实际采集量
      collectBaseList: [], //采集量数据公众
      recommendTableData: [], //推荐单位采集量表格数据
      initiateTableData: [], //发起单位
      volunteerAgencyTableData: [], // 服务机构
      volunteerTableData: [], // 志愿者
      volunteerTeamTableData: [], // 志愿服务队
      subjectTableData: [], // 主问卷/专题采集量 （数量汇总）
      referralTableData: [], // 推荐码
      sortList: [], //分类数据
      recommendTableDataLoading: false,
      volunteerLoading: false,
      tableDataLoading: false,
      tableDataAreaLoading: false,
      thePublicLoading: false,
      referralTableDataLoading: false,
      subjectLoading: false,
      loading: false,
      // 服务站：volunteerOrgName
      // 服务队：volunteerUnitName
      // 志愿者：sourceName
      toolData: {
        category: '',
        sourceName: '',
        sourceId: '',
        province: '',
        recommended: '',
        volunteerOrgName: '',
        volunteerUnitName: '',
        city: ''
      },
      provinceList: [],
      cityList: [],
      //对话框
      dialogRecommendTable: false,
      dialogRecommendTitle: '',
      dialogRecommendData: [],
      dialogRecommendLoading: false,
      showMap: false, //地图
      dealMapData: [],
			showIframe: false,
			showWorldTop: false, // 全国前十
			showFirmTop: false, // 企业前十
			showEducationTop: false, // 教育前十
			isCity: false,
			updateTime: "",
      volunteerActiveName: 'first',
      areaActiveName: 'first',
      unitActiveName: 'first',
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
      dialogWidth: '450px',
      tableWidth: 'width:100%',
      isPc: true,
      provincesAndCitiesTop: [],
      companyTop: [],
      educationTop: [],
      worldList: [], // 全国
      firmList: [], // 企业采集量
      educationList: [], // 教育采集量
      showCodeDia: false,
      cityTableData: [], // 城市列表
      cityTableDataTop100: [], // 城市列表
      dialogcityTop: false,
      dialogcityTopLoading: false,
      areaCityTableData: [], // 城市列表
      areaCityTableDataTop100: [], // 城市列表
      dialogAreaCityTop: false,
      dialogAreaCityTopLoading: false,
    };
  },
  created() {
    this.loading = true;
		this.geojsonData = geojson;
    // this.init()
    this.getSource();
    this.func_get_sort(); // 获取分类
    // console.log('document.body.clientWidth',document.body.clientWidth)
  },
  mounted() {
    const that = this;
    window.onresize = ()=> {
      return (()=> {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        window.screenHeight = document.body.clientHeight;
        that.screenHeight = window.screenHeight;
      })()
    }
  },
  watch: {
    screenWidth: {
      immediate: true,
      handler: function (newVal) {
        if(newVal>768) {
          this.dialogWidth = "450px";
          // this.tableWidth = `width:${newVal}`
          this.isPc = true;

        }else {
          this.dialogWidth = "90%"
          // this.tableWidth = `width:${newVal}`
          this.isPc = false;
        }
      }
    }
  },
	updated() {
    this.$nextTick(() => {
      // this.$refs['table'].doLayout();
      // this.$refs['area'].doLayout();
    })
  },
  beforeUnmount() {
  },
  filters: {
    filterId: function (value) {
      let count = 0;
      for (let i = 0; i < value.length; i++) {
        if (value.charAt(i) === '-') {
          count++;
        }
      }
      if(count===0) {
        return value
      }else {
        return ' '
      }
    },
    filterIdS: function (value) {
      let count = 0;
      for (let i = 0; i < value.length; i++) {
        if (value.charAt(i) === '-') {
          count++;
        }
      }
      if(count===0) {
        return value
      }else if (count===1) {
        let ary = value.split('-')
        return `(${ary[1]})`
      }else {
        return ' '
      }
    },
    desc: function (value) {

    }
  },
  methods: {
    init() {
      this.provinceCity(); // 按省市统计/myd/count/city
      this.getSource(); // 按来源统计/myd/count/city/source
      this.getUnit(); // 按单位统计/myd/count/company
      this.getRemarkUnit(); // 按单位统计/myd/count/company
      this.getVolunteerAgency(); // 按志愿服务机构统计 /myd/count/volunteer/orgName
      this.getVolunteerTeam(); // 志愿服务队
      this.getVolunteer(); // 志愿者
      // this.getSubject(); // 专题统计接口：/myd/count/city/address/
      // this.getReferral();// /myd/count/referral 按推荐码统计
      this.func_get_sort(); // 获取分类
    },
    changeTheme() {
      this.$confirm('是否切换主题?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        if(this.theme.isRed) {
          this.theme= {
            isRed: false,
            bg: 'bg2023_special2.png',
            themeColor: "#1DCBFD",
            bgColor: "#D3F5FB",
            titleBg: 'title2023_2.png',
            subheadBg: 'subhead2023_special2.png',
            lableBg: 'lable2023_2.png',
            tabbt: 'tabbt2023_2.png',
            otherBgColor: "#F77768",
            tabsBg: 'custom-tabs-no-red',
            textColor: 'blue'
          };
        }else {
          this.theme= {
            isRed: true,
            bg: 'bg2023_1.png',
            themeColor: "#EA3E14",
            bgColor: "#F33519",
            titleBg: 'title2023_1.png',
            subheadBg: 'subhead2023_special1.png',
            lableBg: 'lable2023_1.png',
            tabbt: 'tabbt2023_1.png',
            otherBgColor: "#41DBE7",
            tabsBg: 'custom-tabs-red',
            textColor: 'red'
          }
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    changeProvince(val) {
      // provinceList: [],
      // cityList: [],
      this.cityList = [];
      if(!!val) {
        let cityData = this.provinceList.filter(item => item.province === val)
        this.cityList = cityData[0].childrenList;
      }
    },
    // 查询栏目点击搜索
    searchEvent() {
      if (this.nowActive.active == 6) { // 各链接采集量公众网民版,来源
        this.getSource();
      } else if (this.nowActive.active == 5) { // 推荐单位采集量
        if(this.unitActiveName === 'second') {
          this.getRemarkUnit();
        }else {
          this.getUnit();
        }
      } else if (this.nowActive.active == 9) { // 推荐码采集量
        if( !!this.toolData.sourceName && !!this.toolData.sourceId ) {
          this.getReferral();
        }else {
          this.$message({
            message: '推荐码和来源都为必填！',
            type: 'warning'
          });
        }
      } else if (this.nowActive.active == 8) {
      //   this.getVolunteerAgency(); // 按志愿服务机构统计
      // this.getVolunteerTeam(); // 志愿服务队
      // this.getVolunteer(); // 志愿者
        if(this.volunteerActiveName === 'second') {
          this.getVolunteerTeam();
        }else if(this.volunteerActiveName === 'three') {
          this.getVolunteer(); // 志愿者
        }else{
          this.getVolunteerAgency();
        }
      }
    },
    searchCodeEvent() {
      if( !!this.toolData.sourceName && !!this.toolData.sourceId ) {
          this.getReferral();
      }else {
        this.$message({
          message: '推荐码和来源都为必填！',
          type: 'warning'
        });
      }
    },
    // 全国企业采集量
    worldCollect() {
      this.dialogRecommendTable = true;
      this.dialogRecommendLoading = true;
      this.dialogRecommendTitle = "全国企业采集量";

      this.dialogRecommendData = this.firmList;
      this.dialogRecommendLoading = false;
    },
    educationCollect() {
      this.dialogRecommendTable = true;
      this.dialogRecommendLoading = true;
      this.dialogRecommendTitle = "全国学校采集量";
      this.dialogRecommendData = this.educationList;
      this.dialogRecommendLoading = false;
    },
    cityCollect() {
      this.dialogcityTop = true;
      this.dialogcityTopLoading = true;
      this.$nextTick(function() {
        this.dialogcityTopLoading = false;
      });
    },
    areaCityCollect() {
      this.dialogAreaCityTop = true;
      this.dialogAreaCityTopLoading = true;
      this.$nextTick(function() {
        this.dialogAreaCityTopLoading = false;
      });
    },
    // 打开推荐码
    showCodeDialog() {
      this.showCodeDia = true;
    },
    // 2023 省市统计
    provinceCity() {
      this.loading = true;
      this.tableDataLoading = true;
      let params = {
        formKey: this.formKey
      }
      apiInstance.post(`/tduck-api/nic/count/city`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        this.worldList = [];
        this.firmList = [];
        this.educationList = [];
        let childrenList = data.data.childrenList;
        this.cityTableData = [];
        this.cityTableDataTop100 = [];

        this.getChild(childrenList);
        setTimeout(()=> {
          // 企业排序
          this.firmList = this.worldList.filter(item => item.category ==="企业")
          this.firmList = this.firmList.sort(function (a, b) {
            return b.amount - a.amount;
          });
          this.firmList = this.addTotal(this.firmList);
          // 教育排序
          this.educationList = this.worldList.filter(item => item.category ==="教育")
          this.educationList = this.educationList.sort(function (a, b) {
            return b.amount - a.amount;
          });
          this.educationList = this.addTotal(this.educationList);
          this.provincesAndCitiesData = childrenList; // 省市实际采集量
          this.cityTableData.sort(function (a, b) {
            return b.amount - a.amount;
          });
          this.cityTableDataTop100 = this.cityTableData.slice(0, 100);
          this.tableDataLoading = false;
          this.loading = false;
        },0)
      }).catch( error => {
        this.tableDataLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    addTotal(arr=[]) {
      const total = {};
      total.amount= arr.reduce((sum, current) => {
        return sum + current.amount;
      },0)
      total.employmentAmount= arr.reduce((sum, current) => {
        return sum + current.employmentAmount;
      },0)
      total.publicAmount= arr.reduce((sum, current) => {
        return sum + current.publicAmount;
      },0)
      total.id = '0';
      total.name = '/';
      total.category = '合计';
      total.city = '/';
      total.province = '/';
      total.sourceName = '/';
      total.startCompany = '/';
      arr.unshift(total);
      return arr
    },
    //province省->city市->district区->sourceName来源
    getChild(data=[], idx='') {
      if(!!data && data.length > 0) {
        data.forEach((element,index) => {
          if(!idx) {
            element.id = index + 1;
          }else {
            element.id = idx + '-' + ( index + 1 );
          }
          element.isClick = true;
          let count = this.countCharacterOccurrences(element.id, '-')
          element.sublist = [];
          if(count === 0) { // 0当前是省，1当前是市
            element.sublist = element.childrenList;
            if(element.province!=="组委会") {
              let arr = [];
              element.childrenList.forEach(it => {
                it.province = element.province;
                if(it.city!=="协会" && it.city!=="组委会") {
                  arr.push(it)
                }
              });

              this.cityTableData = [...this.cityTableData, ...arr]
            }
          }
          if(element.city && element.city === '广州市') { // 0当前是省，1当前是市
            element.sublist = element.childrenList;
          }
          if(count === 1 && (!!element.sourceList && element.sourceList.length > 0)) { // 1当前是市 汇总全国企业采集量
            // sourceList
            this.worldList = [...this.worldList, ...element.sourceList]
          }
          if(element.hasOwnProperty('childrenList')) {
            this.getChild(element.childrenList, element.id)
          }
        });
      }
    },
    // 判断某个字符在字符串中出现的次数
    countCharacterOccurrences(string, character) {
      let count = 0;
      for (let i = 0; i < string.length; i++) {
        if (string.charAt(i) === character) {
          count++;
        }
      }
      return count;
    },
    // 2023 来源统计
    getSource(row, index) {
      this.loading = true;
      this.thePublicLoading = true;
      let params = {
        formKey: this.formKey,
        sourceName: this.toolData.sourceName,
        province: this.toolData.province,
        category: this.toolData.category,
        city: this.toolData.city,
      }
      apiInstance.post(`/tduck-api/nic/count/city/source`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(data.data.childrenList.length > 0 ) {
          data.data.childrenList.forEach((element, index) => {
            element.id = index+1;
            element.sourceStr = `${element.sourceName}(${element.sourceId})`;
          });
          const total = data.data.childrenList.reduce((acc, cur) => {
            for (const key in cur) {
              if (typeof acc[key] === 'undefined') {
                acc[key] = 0;
              }
              acc[key] += cur[key];
            }
            return acc;
          }, {});
          // province city category sourceName amount
          total.id = 0;
          total.province = '/';
          total.city = '/';
          total.category = '/';
          total.sourceStr = '合计';
          data.data.childrenList.unshift(total);
          this.collectBaseList = data.data.childrenList;
        }
        // this.collectBaseList = data.data.publicList;
        // this.collectProList = data.data.employmentList;
        this.provinceList = data.data.provinceList;
        this.thePublicLoading = false;
        this.loading = false;

      }).catch( err => {
        this.loading = false;
        this.thePublicLoading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
		},

    // areaCityTableData: [], // 城市列表
    //   areaCityTableDataTop100: [], // 城市列表
    //   dialogAreaCityTop: false,
    //   dialogAreaCityTopLoading: false,

    // 2023按单位统计
    getUnit() {
      this.recommendTableDataLoading = true;
      let params = {
        formKey: this.formKey,
        startCompany: this.toolData.recommended,
      }
      apiInstance.post(`/tduck-api/nic/count/company`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        data.data.childrenList.forEach((element,index) => {
          element.id = index+1;
        });
        this.initiateTableData = data.data.childrenList; // 发起单位
        this.recommendTableDataLoading = false;
      }).catch( err => {
        this.recommendTableDataLoading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 推荐单位
    getRemarkUnit() {
      this.recommendTableDataLoading = true;
      let params = {
        formKey: this.formKey,
        remarks: this.toolData.recommended,
      }
      apiInstance.post(`/tduck-api/nic/count/remark`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        data.data.childrenList.forEach((element,index) => {
          element.id = index+1;
        });
        this.recommendTableData = data.data.childrenList; // 推荐单位
        this.recommendTableDataLoading = false;
      }).catch( err => {
        this.recommendTableDataLoading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 2023按推荐码 getReferral
    getReferral() {
      this.referralTableDataLoading = true;
      let params = {
        formKey: this.formKey,
        sourceName: this.toolData.sourceName,
        sourceId: this.toolData.sourceId
      }
      apiInstance.post(`/tduck-api/nic/count/referral`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(!!data.data && !!data.data.sourceName) {
          let tableData = this.addNo([data.data]);
          this.referralTableData = tableData;
        }else {
          this.referralTableData = []
        }
        this.referralTableDataLoading = false;
      }).catch(err => {
        this.$message.error('出错了，请联系工作人员！');
        this.referralTableDataLoading = false;
      });
    },
    addNo(data=[], idx='') {
      if(!!data && data.length > 0) {
        data.forEach((element,index) => {
          if(!idx) {
            element.id = index + 1;
          }else {
            element.id = idx + '-' + ( index + 1 );
          }
          if(element.hasOwnProperty('childrenList')) {
            this.addNo(element.childrenList, element.id)
          }
        });
      }
      return data;
    },
    // 点击推荐单位
    clickRecommend(row, index) {
      this.dialogRecommendTable = true;
      this.dialogRecommendLoading = true;
      this.dialogRecommendTitle = row.name;
      if(!!row.sourceList && row.sourceList.length > 0) {
        const total = {};
        total.amount= row.sourceList.reduce((sum, current) => {
          return sum + current.amount;
        },0)
        total.employmentAmount= row.sourceList.reduce((sum, current) => {
          return sum + current.employmentAmount;
        },0)
        total.publicAmount= row.sourceList.reduce((sum, current) => {
          return sum + current.publicAmount;
        },0)
        total.id = '0';
        total.name = '/';
        total.category = '/';
        total.city = '/';
        total.province = '/';
        total.sourceName = '合计';
        total.startCompany = '/';
        // row.sourceList.unshift(total);
        this.dialogRecommendData = [ ...[total], ...row.sourceList];
      }else {
        this.dialogRecommendData = []
      }
      this.dialogRecommendLoading = false;
    },
    // 2023按志愿服务
    getVolunteerAgency() {
      this.volunteerLoading = true;
      let params = {
        formKey: this.formKey,
        volunteerOrgName: this.toolData.volunteerOrgName
      }
      apiInstance.post(`/tduck-api/nic/count/volunteer/orgName`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let childrenList = data.data.childrenList;
        this.getVolunteerChild(childrenList);
        setTimeout(()=> {
          this.volunteerAgencyTableData = childrenList; // 省市实际采集量
          this.volunteerLoading = false;
        },0)
      }).catch( error => {
        this.volunteerLoading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    getVolunteerTeam() {
      // /myd/count/volunteer/unitName
      this.volunteerLoading = true;
      let params = {
        formKey: this.formKey,
        volunteerUnitName: this.toolData.volunteerOrgName
      }
      apiInstance.post(`/tduck-api/nic/count/volunteer/unitName`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let childrenList = data.data.childrenList;
        this.getVolunteerChild(childrenList);
        setTimeout(()=> {
          this.volunteerTeamTableData = childrenList; // 省市实际采集量
          this.volunteerLoading = false;
        },0)
      }).catch( error => {
        this.volunteerLoading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 志愿者
    getVolunteer() {
      // /myd/count/volunteer/person
      this.volunteerLoading = true;
      let params = {
        formKey: this.formKey,
        sourceName: this.toolData.sourceName
      }
      apiInstance.post(`/tduck-api/nic/count/volunteer/person`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let childrenList = data.data.childrenList;
        this.getVolunteerChild(childrenList);
        setTimeout(()=> {
          this.volunteerTableData = childrenList; // 省市实际采集量
          this.volunteerLoading = false;
        },0)
      }).catch( error => {
        this.volunteerLoading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    getVolunteerChild(data=[], idx='') {
      if(!!data && data.length > 0) {
        data.forEach((element,index) => {
          if(!idx) {
            element.id = index + 1;
          }else {
            element.id = idx + '-' + ( index + 1 );
          }
          element.isClick = true;
          let count = this.countCharacterOccurrences(element.id, '-')
          element.sublist = [];
          if(count === 0 || element.city) { // 0当前是省，1当前是市
            element.sublist = element.childrenList;
          }
          if(element.hasOwnProperty('childrenList')) {
            this.getVolunteerChild(element.childrenList, element.id)
          }
        });
      }
    },

    // 专题统计接口：/myd/count/city/address/
    getSubject() {
      this.subjectLoading = true;
      this.tableDataAreaLoading = true;

      let params = {
        formKey: this.formKey,
      }
      apiInstance.post(`/tduck-api/nic/count/city/address/special`, params).then(res => {
        let { data } = res;
        this.areaCityTableData = []; // 城市列表
        this.areaCityTableDataTop100 = []; // 城市列表
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        this.getAreaChild(data.data.childrenList)
        setTimeout(()=> {
          if(data.data.childrenList.length>0) {
            const total = data.data.childrenList.reduce((acc, cur) => {
              for (const key in cur) {
                if (typeof acc[key] === 'undefined') {
                  acc[key] = 0;
                }
                acc[key] += cur[key];
              }
              return acc;
            }, {});
            total.id = '0';
            total.name = '合计';
            total.specialPercentDesc = '100.0%';
            total.percentDesc = '100.0%';
            total.publicPercentDesc = '100.0%';
            total.totalAmountPercentDesc = '100.0%';
            total.secondStagePercentDesc = '100.0%';
            total.firstStagePercentDesc = '100.0%';
            total.stagePercentDesc = '100.0%';
            data.data.childrenList.unshift(total);
            this.subjectTableData = data.data.childrenList;
            this.totalAreaData = data.data.childrenList;
            // this.totalAreaData = [...data.data.childrenList].sort((a, b) => {
            //   // 根据 id 属性进行降序排序
            //   return b.amount - a.amount;
            // });
          }
          this.areaCityTableData.sort(function (a, b) {
            return b.totalAmount - a.totalAmount;
          });
          this.areaCityTableData = this.areaCityTableData.filter(item=>item.totalAmount !== 0 && item.city !=="未知")
          this.areaCityTableDataTop100 = this.areaCityTableData.slice(0, 100);
          this.subjectLoading = false;
          this.tableDataAreaLoading = false;
          this.loading = false;
        },0)
      }).catch( error => {
        this.subjectLoading = false;
        this.tableDataAreaLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    getAreaChild(data=[], idx='') {
      if(!!data && data.length > 0) {
        data.forEach((element,index) => {
          if(!idx) {
            element.id = index+1;
          }else {
            element.id = idx + '-' + (index+1);
          }
          element.isClick = false;
          let count = this.countCharacterOccurrences(element.id, '-')
          element.sublist = [];
          if(count === 0 ) { // 0当前是省，1当前是市
            element.sublist = element.childrenList;
            if(element.province!=="组委会" && element.province!=="国外") {
              let arr = [];
              element.childrenList.forEach(it => {
                it.province = element.province;
                if(it.city!=="协会" && it.city!=="组委会") {
                  arr.push(it)
                }
              });

              this.areaCityTableData = [...this.areaCityTableData, ...arr]
            }
          }
          if(element.hasOwnProperty('childrenList')) {
            this.getAreaChild(element.childrenList, element.id)
          }
        });
      }
    },

    //获取分类
    func_get_sort() {
      apiInstance.get(`/tduck-api/nic/count/category/list`,
      {},
      {Accept: "application/json"},
      ).then(res => {
        let { data } = res;
        this.sortList = data.data
      }).catch( error => {
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 各链接采集量
    getSummariesSecond(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if(this.isPc) {
          if (index === 0 ) {
            sums[index] = '0';
            return;
          }else if(index === 2 || index ===1 || index ===3) {
            sums[index] = '/';
            return;
          } else if (index === 4) {
            sums[index] = '合计';
            return;
          }
        }else {
          if (index === 0 ) {
            sums[index] = '0';
            return;
          }else if(index === 2 || index ===1) {
            sums[index] = '/';
            return;
          } else if (index === 3) {
            sums[index] = '合计';
            return;
          }
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = '100.00%';
        }
      });
      return sums;
    },
    // 推荐单位采集量 合计列
    getSummariesZG(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        const values = data.map(item => item[column.property]);
        let sum = 0;
        values.forEach(function(item,index){
          if(item==null){
            item=0
          }
          if(typeof(item) == 'string'&&item.indexOf('%')>0){
            item=Number(item.split('%')[0])
          }
          var aaa = Number(item)
          if(!isNaN(aaa)){
            sum = sum + Number(item)
          }else{
            sum = null
          }
        })
        if (index === 0) {
          sums[index] = '0';
          return;
        }
        if (index === 1) {
          sums[index] = '合计';
          return;
        }
        if (index === 2||index === 4||index === 5) {
          sums[index] = sum;
          return;
        }
        if (index === 3) {
          sums[index] = Math.round(sum).toFixed(2) + "%";
          return;
        }
      });
      return sums;
    },
    // 发起推荐单位采集量 合计列
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        const values = data.map(item => item[column.property]);
        let sum = 0;
        values.forEach(function(item,index){
          if(item==null){
            item=0
          }
          if(typeof(item) == 'string'&&item.indexOf('%')>0){
            item=Number(item.split('%')[0])
          }
          var aaa = Number(item)
          if(!isNaN(aaa)){
            sum = sum + Number(item)
          }else{
            sum = null
          }
        })
        if (index === 0) {
          sums[index] = '0';
          return;
        }
        if (index === 1) {
          sums[index] = '合计';
          return;
        }
        if (index === 2) {
          sums[index] = sum;
          return;
        }
        if (index === 3) {
          sums[index] = Math.round(sum).toFixed(2) + "%";
          return;
        }
        if (index === 4) {
          sums[index] = "/";
          return;
        }
      });
      return sums;
    },
    getSummariesVolunteer(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        const values = data.map(item => item[column.property]);
        let sum = 0;
        values.forEach(function(item,index){
          if(item==null){
            item=0
          }
          if(typeof(item) == 'string'&&item.indexOf('%')>0){
            item=Number(item.split('%')[0])
          }
          var aaa = Number(item)
          if(!isNaN(aaa)){
            sum = sum + Number(item)
          }else{
            sum = null
          }
        })
        if (index === 0) {
          sums[index] = '0';
          return;
        }
        if (index === 1 || index === 2) {
          sums[index] = '/';
          return;
        }
        if (index === 3) {
          sums[index] = '合计';
          return;
        }
        if (index === 4 || index === 6 || index === 7) {
          sums[index] = sum;
          return;
        }
        if (index === 5) {
          sums[index] = Math.round(sum).toFixed(2) + "%";
          return;
        }
      });
      return sums;
    },
    getSummariesReferral(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0 ) {
          sums[index] = '';
          return;
        } else if (index === 1) {
          sums[index] = '贡献值';
          return;
        } else if (data.length > 0) {
          if (index === 2) {
            sums[index] = data[0].publicReferralAmount;
            return;
          } else if (index === 3) {
            sums[index] = data[0].employmentReferralAmount;
            return;
          } else if (index === 4) {
            sums[index] = data[0].referralAmount;
            return;
          }
        }else {
            sums[index] = '';
            return;
        }
      });
      return sums;
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex === 0) {
        return 'success-row';
      }
      return '';
    },
    // 专题合计
    getSubjectSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0 ) {
          sums[index] = '0';
          return;
        }else if(index ===1) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = '/';
        }
      });
      return sums;
    },
    changeUnitTabelTab({name}) {
      this.loading = true;
      this.recommendTableDataLoading = true;
      this.toolData.recommended = '';
      if(name=='second') {
        this.getRemarkUnit();
      }else {
        this.getUnit();
      }
      let ref=(name=='second'?'recommended':'initiate')
      setTimeout(()=>{
        this.$refs[ref].doLayout()
        this.recommendTableDataLoading = false;
        this.loading = false;
      },100)
    },
    changeAreaTabelTab({name}) {
      this.loading = true;
      this.tableDataAreaLoading = true;
      this.subjectLoading = true;
      let ref=(name=='second'?'subject':'area')
      setTimeout(()=>{
        this.$refs[ref].doLayout()
        this.tableDataAreaLoading = false;
        this.subjectLoading = false;
        this.loading = false;
      },100)
    },
    changeVolunteerTabelTab({name}) {
      this.loading = true;
      this.showMap = false;
      let ref = '';
      if(name === 'first') {
        ref = 'agency';
      }else if(name === 'second') {
         ref = 'team';
      }else if(name === 'three') {
         ref = 'volunteer';
      }else {
        ref = 'agency';
      }
      setTimeout(()=>{
        this.$refs[ref].doLayout()
        this.loading = false;
      },100)
    },
    // 选择tab,改变表格数据
    changeTab(active) {
      this.loading = true;
      this.toolData = {
        category: '',
        sourceName: '',
        sourceId: '',
        province: '',
        recommended: '',
        volunteerOrgName: '',
        volunteerUnitName: '',
        city: ''
      };
      if (active == 1) {
        this.provinceCity();
      }else if (active == 2) {
        this.getSubject();
      }else if (active == 6) { // 各链接采集量公众网民版,来源
        this.getSource();
      } else if (active == 5) { // 推荐单位采集量
        // this.getRemarkUnit();
        this.getUnit();
      } else if (active == 8) {
          this.getVolunteerTeam();
          this.getVolunteer(); // 志愿者
          this.getVolunteerAgency();
      }
      this.activeTab.forEach(e => {
        e.show = false;
        if (e.active == active) {
          e.show = true;
          this.nowActive = e;
          return
        }

      });
      this.showMap = false; // 切换时隐藏地图
      setTimeout(() => {
        this.loading = false;
      }, 1000)
    },
    exportSourceData(title, type) {
      this.loading = true;
      this.dialogRecommendLoading = true;

      let params = {};
      let url = '';
      if(type==='second') { // 推荐单位
        url = '/tduck-api/nic/export/remark/source';
        params = {
          formKey: this.formKey,
          remarks: title,
        }
      }else { // 发起单位
        url = '/tduck-api/nic/export/company/source';
        params = {
          formKey: this.formKey,
          startCompany: title,
        }
      }
      apiInstance({
				method: 'post',
				url: url,
				data: params,
				responseType: 'arraybuffer'
			}).then(res => {
        this.loading = false;
        this.dialogRecommendLoading = false;
				let blob = new Blob([res.data], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
				});
				let a = document.createElement("a"); // 创建a标签
				a.style.display = "none";
				let objectUrl = URL.createObjectURL(blob);
        if(type==='second') { // 推荐单位
          a.download = `2023年推荐单位(${title}).xlsx`;
        }else { // 发起单位
          a.download = `2023年发起单位(${title}).xlsx`;
        }
				a.href = objectUrl;
				a.click();
				URL.revokeObjectURL(objectUrl);
			}).catch( error => {
        this.loading = false;
        this.dialogRecommendLoading = false;
        this.$message.error('导出出错了，请联系工作人员！');
      });
    },
    exportVolunteerData() {
      this.loading = true;
      let params = {};
			let url = '/tduck-api/nic/export/volunteer';
      params = {
        formKey: this.formKey,
      }
      apiInstance({
				method: 'post',
				url: url,
				data: params,
				responseType: 'arraybuffer'
			}).then(res => {
        this.loading = false;
				let blob = new Blob([res.data], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
				});
				let a = document.createElement("a"); // 创建a标签
				a.style.display = "none";
				let objectUrl = URL.createObjectURL(blob);
				a.download = `2023年服务机构.xlsx`;
				a.href = objectUrl;
				a.click();
				URL.revokeObjectURL(objectUrl);
			}).catch( error => {
        this.loading = false;
        this.$message.error('导出出错了，请联系工作人员！');
      });
    },
		// 导出数据功能
		exportData() {
      this.loading = true;
			let params = {};
			let url = '';
      params = {
        formKey: this.formKey,
      }
			if(this.nowActive.active == 1) { // 各省市实际采集量
				url = `/tduck-api/nic/export/city`;
			}else if(this.nowActive.active == 2) { // 参与答题网民区域分布
        url = `/tduck-api/nic/export/special`; // 主问卷/专题采集量 （数量汇总）
			}else if(this.nowActive.active == 5) { // 单位
        if(this.unitActiveName==='second') { // 推荐
          params = {
            formKey: this.formKey,
            remarks: this.toolData.recommended,
          }
          url = `/tduck-api/nic/export/remark`;
        }else { // 发起
          params = {
            formKey: this.formKey,
            startCompany: this.toolData.recommended,
          }
          url = `/tduck-api/nic/export/company`;
        }
			}else if(this.nowActive.active == 6) { // 各链接
				url = `/tduck-api/nic/export/source`;
        params = {
          formKey: this.formKey,
          sourceName: this.toolData.sourceName,
          province: this.toolData.province,
          category: this.toolData.category,
          city: this.toolData.city,
        }
			}else if(this.nowActive.active == 8) { // 志愿服务机构
				url = `/tduck-api/nic/export/volunteer`;
        params = {
          formKey: this.formKey,
          volunteerOrgName: this.toolData.volunteerOrgName
        }
			}
			apiInstance({
				method: 'post',
				url: url,
				data: params,
				responseType: 'arraybuffer'
			}).then(res => {
        this.loading  = false;
				let blob = new Blob([res.data], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
				})
				let a = document.createElement("a"); // 创建a标签
				a.style.display = "none";
				let objectUrl = URL.createObjectURL(blob);
        if(this.nowActive.active == 5) {
          if(this.unitActiveName =='second') {
            a.download = `${this.year}推荐单位.xlsx`; // 主问卷/专题采集量 （数量汇总）
          }else {
            a.download = `${this.year}发起单位.xlsx`; // 样本采集（汇总统计）
          }
        }else {
				  a.download = `${this.year}${this.nowActive.title}.xlsx`;
        }
				a.href = objectUrl;
				a.click();
				URL.revokeObjectURL(objectUrl);
			}).catch( error => {
        this.loading  = false;
        this.$message.error('导出出错了，请联系工作人员！');
      });;
		},
    // 地图
    mapEvent() {
      this.showMap = true;
      // 开始画地图
      // <div id="mapContainer" class="calDataShow mapDivisionData"></div>
      let data = [];
      if (this.nowActive.active == 2) { //参与答题网民区域分布
        data = this.subjectTableData;
      } else if (this.nowActive.active == 1) {
        data = this.provincesAndCitiesData;
      } else if (this.nowActive.active == 8 && this.volunteerActiveName === 'first') {
        data = this.volunteerAgencyTableData;
      } else if (this.nowActive.active == 8 && this.volunteerActiveName === 'second') {
        data = this.volunteerTeamTableData;
      }
      this.dealMapData = this.func_deal_map(data); // 处理地图数据
      console.log('this.dealMapData',this.dealMapData)

      setTimeout(() => {
        this.func_init_map(); // 初始化地图
      })
    },
		tableEvent() {
			this.showMap = false;
		},
    func_init_map() {
      let maxNumber = 30000;
      if( this.nowActive.active == 8 ) {
        maxNumber = 10000;
      }
      let geoJson = this.geojsonData;
      var chartDom = document.getElementById('mapContainer');
      myChart = echarts.init(chartDom);
      var option;
      echarts.registerMap('china', geoJson);
      myChart.setOption(
        (option = {
          title: {
            text: '',
            left: 'center',
            subtext: '',
            sublink:
              'http://zh.wikipedia.org/wiki/%E9%A6%99%E6%B8%AF%E8%A1%8C%E6%94%BF%E5%8D%80%E5%8A%83#cite_note-12'
          },
          toolbox: {
            feature: {
              myTool1: {
                show: true,
                title: '放大',
                icon: 'image://https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/amplification.png',
                onclick: function (res) {
                  myChart.setOption({
                    series: [{
                      zoom: res.option.series[0].zoom + 0.5,
                      roam: 'move'
                    }]
                  });
                }
              },
              myTool2: {
                show: true,
                title: '还原',
                icon: 'image://https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/restore.png',
                onclick: function (res) {
                  myChart.setOption({
                    series: [{
                      zoom: 1.1,
                      roam: 'move'
                    }]
                  });
                }
              }
            }

          },
          tooltip: {
            trigger: 'item',
            // triggerOn: 'item', //点击才显示tooltip，item 图形触发，axis 坐标轴触发， none 不触发
            borderWidth: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            // formatter: '答卷数<br/>{b}:{c}'
            formatter: function (param) {
              return param.marker + " " + param.seriesName + "<br>"
                + "&nbsp;&nbsp;&nbsp;&nbsp;" + param.name + "：" + param.value + "<br>";
            }
          },
          visualMap: {
            top: 'top',
            type: "continuous",
            min: 0,
            max: maxNumber,
            realtime: false,
            calculable: true,
            inRange: {
              color: ['#25B0F3', '#0000CD']
            }
          },
          series: [
            {
              name: '答卷次数',
              type: 'map',
              roam: 'move',//true即为缩放+拖动
              left: "10%",                                 //组件离容器左侧的距离,百分比字符串或整型数字
              top: "10%",                                      //组件离容器上侧的距离，百分比字符串或整型数字
              right: "10%",                               //组件离容器右侧的距离,百分比字符串或整型数字
              bottom: "10%",                              //组件离容器下侧的距离,百分比字符串或整型数字
              map: 'china',
              zoom: 1.1,
              itemStyle: {
                emphasis: {
                  // 鼠标悬浮地图区域的高亮颜色
                  areaColor: '#90ED87'
                }
              },
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    fontSize: 10,
                    fontWeight: '',
                    color: '#fff' //修改地图上文字的颜色
                  }
                },
                emphasis: {
                  textStyle: {
                    color: '#000'
                  }
                }
              },
              select: {
                lable: {
                  color: '#fff'
                },
                itemStyle: {
                  areaColor: '#90ED87'
                }
              },
              data: this.dealMapData
            }
          ]
        })
      );
      option && myChart.setOption(option);
    },
    // 处理地图数据
    func_deal_map(mapObj) {
      let dealData = []
      let features = [];
      features = this.geojsonData.features;
      const sum = Object.values(mapObj.reduce((accumulator, current) => {
        const { province, amount } = current;

        if (!accumulator[province]) {
          accumulator[province] = { province, amount: 0 };
        }

        accumulator[province].amount += amount;

        return accumulator;
      }, {}));
      sum.forEach(item => {
        // if (item.province === '北京' || item.province === '天津' || item.province === '上海' || item.province === '重庆') {
        //   dealData.push({
        //     name: `${item.province}市`,
        //     value: item.amount,
        //     label: {
        //       normal: {
        //         show: true,
        //         formatter: function (params) {
        //           return item.amount;
        //         },
        //       }
        //     },
        //   })
        // } else if (item.province === '香港' || item.province === '澳门') {
        //   dealData.push({
        //     name: `${item.province}`,
        //     value: item.amount,
        //     label: {
        //       normal: {
        //         show: true,
        //         formatter: function (params) {
        //           return item.amount;
        //         },
        //       }
        //     },
        //   })
        // } else if (item.province === '内蒙古' || item.province === '西藏') {
        //   dealData.push({
        //     name: `${item.province}自治区`,
        //     value: item.amount,
        //     label: {
        //       normal: {
        //         show: true,
        //         formatter: function (params) {
        //           return item.amount;
        //         },
        //       }
        //     },
        //   })
        // } else if (item.province === '广西') {
        //   dealData.push({
        //     name: `${item.province}壮族自治区`,
        //     value: item.amount,
        //     label: {
        //       normal: {
        //         show: true,
        //         formatter: function (params) {
        //           return item.amount;
        //         },
        //       }
        //     },
        //   })
        // } else if (item.province === '宁夏') {
        //   dealData.push({
        //     name: `${item.province}回族自治区`,
        //     value: item.amount,
        //     label: {
        //       normal: {
        //         show: true,
        //         formatter: function (params) {
        //           return item.amount;
        //         },
        //       }
        //     },
        //   })
        // } else if (item.province === '新疆') {
        //   dealData.push({
        //     name: `${item.province}维吾尔自治区`,
        //     value: item.amount,
        //     label: {
        //       normal: {
        //         show: true,
        //         formatter: function (params) {
        //           return item.amount;
        //         },
        //       }
        //     },
        //   })
        // } else {
        //   dealData.push({
        //     name: `${item.province}省`,
        //     value: item.amount,
        //     label: {
        //       normal: {
        //         show: true,
        //         formatter: function (params) {
        //           return item.amount;
        //         },
        //       }
        //     },
        //   })
        // }
        if(!!item.province) {
          dealData.push({
            name: `${item.province}`,
            value: item.amount,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  return item.amount;
                },
              }
            },
          })
        }

      });
      // 防止有遗漏的省市，影响地图初始化
      features.forEach(i => {
        let result = dealData.some(item => {
          return item.name === i.properties.name
        })
        if (!result) {
          dealData.push({
            name: i.properties.name,
            value: 0,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  return 0;
                },
              }
            },
          })
        }
      });
      return dealData || [];
    },
    // 两个top10
		openIframe(type) {
			// let url = ''
      let data = []
			if(type == 1) {
        // this.provincesAndCitiesData
        for(let item in this.provincesAndCitiesData) {
          let name = this.provincesAndCitiesData[item].name;
          if(!!name && name!=='/' && name!=='合计') {
            data.push({
              name: name
            })
          }
          if(data.length >=10) {
            break
          }
        }
        this.provincesAndCitiesTop = data;
        this.showWorldTop = true;
        this.showFirmTop = false;
        this.showEducationTop = false;
			}else if(type == 2) {
        // 企业前十
        for(let item in this.firmList) {
          let name = this.firmList[item].name;
          if(!!name && name!=='/' && name!=='合计') {
            data.push({
              name: name,
              amount: this.firmList[item].amount
            })
          }
          if(data.length >=10) {
            break
          }
        }
        this.companyTop = data;
        this.showWorldTop = false;
        this.showFirmTop = true;
        this.showEducationTop = false;
      }else if(type == 3) {
        // 教育前十
        for(let item in this.educationList) {
          let name = this.educationList[item].name;
          if(!!name && name!=='/' && name!=='合计') {
            data.push({
              name: name,
              amount: this.educationList[item].amount
            })
          }
          if(data.length >=10) {
            break
          }
        }
        this.educationTop = data;
        this.showWorldTop = false;
        this.showFirmTop = false;
        this.showEducationTop = true;
      }
			this.showIframe = true;
		},
		closeIframe() {
			this.showIframe = false;
		},
    createPlacard(row, index) {
      this.loading = true;
      if(!!this.updateTime) {
        let number = 0;
        if(row.amount >= 1000) {
          number = parseInt(row.amount / 100) * 100
        }else {
          number = parseInt(row.amount / 10) * 10
        }
        let date = this.updateTime.split(' ');
        let dayAry = date[0].split('-');
        let timeAry = date[1].split(':');
        this.placardObj = {
          amount: number,
          name: row.name,
          time: `${dayAry[1]}月${dayAry[2]}日 ${timeAry[0]}:${timeAry[1]}`
        };
        this.$nextTick(()=>{
          setTimeout(()=>{
            this.showPlacard = true;
            this.loading = false;
          }, 1000)
        });
        // this.generatePoster();
      }else{
        this.loading = false;
        this.showPlacard = false;
        this.$message.error('请稍后再试！！！');
      }
    },
    openImg() {
      this.$nextTick(()=>{
        console.log('this.$refs.poster',this.$refs.poster)
        if(this.$refs.poster.id == 'poster') {
          const posterElement = this.$refs.poster;
          html2canvas(posterElement, {
            useCORS: true, // 解决跨域问题
            scale: window.devicePixelRatio,
          }).then(canvas => {
              // // 将 Canvas 转换为数据URI
              // const dataURI = canvas.toDataURL('image/jpeg');

              // // 创建一个下载链接
              // const link = document.createElement('a');
              // link.href = dataURI;
              // link.download = '喜报.jpg';

              // // 触发点击事件
              // link.style.display = 'none'; // 隐藏链接
              // document.body.appendChild(link);
              // link.click();
              // document.body.removeChild(link);


              // 将 Canvas 转换为 Blob 对象
              canvas.toBlob((blob) => {
                // 创建一个临时链接
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${this.placardObj.name}-${this.placardObj.amount}喜报.jpg`; // 设置下载文件的名称

                // 触发点击事件
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();

                // 释放临时链接
                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
              });
          }).catch(err => {
            this.$message.error(err);
          });
        }else {
          this.$message.error('请稍后再试！！！');
        }
      })
    },
    generatePoster() {
      this.$nextTick(()=>{
        console.log('this.$refs.poster',this.$refs.poster)
        if(this.$refs.poster.id == 'poster') {
          const posterElement = this.$refs.poster;
          html2canvas(posterElement, {
            useCORS: true, // 解决跨域问题
          }).then(canvas => {
            const posterImage = canvas.toDataURL('image/jpg');
            // 在这里你可以保存或显示生成的海报图像
            // 如果要保存为文件，可以创建一个下载链接
            const link = document.createElement('a');
            link.href = posterImage;
            link.download = `${this.placardObj.name}-${this.placardObj.amount}喜报.jpg`;
            link.click();
          });
        }else {
          this.$message.error('请稍后再试！！！');
        }
      })

    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container-box {
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
  /* background-size: contain !important; */
  background-size: 100% auto !important;
}
.calcu-content {
  min-height: 450px;
  margin: 0 auto;
  padding-bottom: 50px;
  border-radius: 0 0 10px 10px;
  padding-top: 4%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content-start {
  position: fixed;
  top: 25%;
  right: 0.5%;
  text-align: right;
  z-index: 99;
}
.content-title {
  width: 80%;
  text-align: center;
}
.content-subhead {
  width: 55%;
  text-align: center;
}
.content-btn {
  width: 60%;
  line-height: 35px;
  font-size: 18px;
  text-align: center;
  color: #fff5bf;
	margin-bottom: 10px;
}
.content-btn .btn-box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.content-btn .btn-box .btn-box-bg {
	cursor: pointer;
  width: 15%;
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center center;
}
.content-table {
  width: 90%;
  position: relative;
  overflow: hidden;
}
.innerBg {
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
  position: relative;
}
.innerBg img {
  width: 100%;
  height: auto;
  border: 0;
  max-width: 100%;
  display: block;
}
.innerBg-box {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 1)
  );
  overflow: hidden;
  margin-top: -6%;
  padding-top: 7%;
}
.tab-box {
  background: #fff;
  margin-top: -2px;
}
.tab-title {
  text-align: center;
  font-weight: bold;
  font-size: 32px;
  padding-bottom: 25px;
}
.selection-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto 6%;
}
.selection-area .sel-tab {
  flex: 1;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin: 0 10px;
	padding: 0 10px;
  height: 50px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  display: flex;
	flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  min-width: 45px;
}
.selection-area .sel-tab div {
	flex: 1;
}
.selection-area .add-tips {
  font-size: 12px;
}
.table-box {
  margin: auto;
  background: #fff;
  padding-bottom: 40px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  margin-top: -2px;
  /* max-height: 1500px; */
  min-height: 540px;
}
.table-box .table {
  margin: auto 6%;
}
.table-box .table .sel-header {
  margin: 0;
  color: #fff;
  font-size: 20px;
  text-align: center;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  position: relative;
}
.table .sel-tips {
  width: 100%;
  margin: 10px auto;
}
.table .update-time {
  /* position: absolute;
  top: 36px;
  right: 10px; */
  text-align: right;
  padding-right: 10px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
}
.table .update-time span {
	margin-left: 2px;
}
.table .tips-top {
  /* position: absolute;
  top: 36px;
  left: 10px; */
  text-align: left;
  padding-top: 10px;
  padding-left: 10px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  margin-bottom: -12px;
}
.table .tips-top span {
  display: inline-block;
  margin-right: 5px;
  line-height: 20px;
  text-decoration: underline;
  cursor:pointer;
}
.top-link:hover {
  color: #0a0a0a;
}
.table .tool-bar {
  margin: 10px auto;
  display: flex;
  justify-content: center;
}
.end-tool-bar {
  display: flex;
  justify-content: flex-end!important;
}
.tool-bar .tool-input {
  margin-bottom: 10px;
}
.tool-input .el-select {
  width: 100%;
}
.table .caculate-area {
  width: 100%;
  margin: 0 auto 0;
  min-height: 50px;
  /* height: 750px; */
  position: relative;
  background: #fff;
}
.caculate-area .data-scroll-area {
  /* border: 1px solid #ddd; */
  overflow: auto;
}
.dialog-box {
  /* height: 90%;
  max-height: 670px; */
  overflow: auto;
}
.mapDivisionData {
  /* width: 100%; */
  /* height: 1100px; */
}
.iframe-box {
  width: 100%;
  min-height: 640px;
  height: calc(90vw*1080/2196);
}
.iframe-box iframe {
	width: 100%;
	height: 100%;
}
/* tab样式 */
.tabs-box {
  margin: 20px auto;
}
.tabs-box /deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
.tabs-box /deep/ .el-tabs--card>.el-tabs__header {
  /* border: none; */
}
.tabs-box /deep/ .el-table {
  border: 1px solid #ddd;
}
.tabs-box /deep/ .el-tabs__header {
  margin: 0;
}
.tabs-box /deep/ .el-tabs__nav {
  border: none;
  width: 100%;
  display: flex;
  justify-content: center;
}
.tabs-box /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item:first-child {
  border: 1px solid #ddd;
}
.tabs-box /deep/ .el-tabs__item {
  border-radius: 5px 5px 0 0;
  border: 1px solid #ddd;
  width: 25%;
  text-align: center;
  padding: 0!important;
}
.tabs-box /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}
.tabs-box /deep/ .el-tabs__item:hover {
  color: #ddd;
  /* color: #303133; */
}

.tabs-row-2 /deep/ .el-tabs__item {
  height: 50px;
}
.tabs-box /deep/ .el-tabs__item.is-active {
  color: #fff;
  /* background-color: #F89A67; */
}
.tabs-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.custom-tabs-red /deep/ .el-tabs__item.is-active {
  background-color: #F89A67;
}
.custom-tabs-no-red /deep/ .el-tabs__item.is-active {
  background-color: #23c2de;
}
.caculate-area /deep/ .el-table .cell {
  padding-left: 5px;
  padding-right: 5px;
  /* transform: scale(0.8); */
  line-height: 16px;
}
.total-table /deep/ .el-table__footer-wrapper {
    position: absolute;
    top: 48px;
    left: 0;
}
.total-table /deep/ .el-table__body-wrapper {
    margin-top: 46px;
}
.total-table-2 /deep/ .el-table .success-row {
  background: #F5F7FA;
  position: sticky;
  top: 0px;
  background-color: #f5f7fa;
  z-index: 1;
}
.total-table-3 /deep/ th {
  border: 1px solid #ebeef5;
}
.total-table-3 /deep/ td {
  border: 1px solid #ebeef5;
}
.total-table-3 /deep/ .el-table th.el-table__cell>.cell {
  white-space: pre-line;
}
.caculate-area /deep/ .el-table [class*=el-table__row--level] .el-table__expand-icon {
  width: 20px;
  margin-left: -20px;
}
.caculate-area /deep/ .el-table .el-table__indent {
  padding: 0!important;
}
.dialog-container /deep/ .el-table [class*=el-table__row--level] .el-table__expand-icon {
  width: 20px;
  margin-left: -20px;
}
.dialog-container /deep/ .el-table .el-table__indent {
  padding: 0!important;
}
.poster {
  position: relative;
  width: 540px;
  height: 810px;
  margin-bottom: 20px;
}
.background-image {
  width: 100%;
  height: 100%;
}

.poster-text {
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translateX(-50%);
  color: #EE3C38;
  text-align: center;
  width: 100%;
}
.poster-text .text-1 {
  color: #FE3232;
  font-family: CustomFont1;
  letter-spacing: 1px;
  font-size: 20px;
  line-height: 22px;
}
.poster-text .text-2 {
  color: #DA2618;
  font-family: CustomFont2;
  width: 100%;
  height: 56px;
  line-height: 26px;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.poster-text .text-2 div{
  width: 80%;
}
.poster-text .text-3 {
  font-family: CustomFont3;
  letter-spacing: 2px;
  font-size: 64px;
  line-height: 70px;
}
.poster-text .text-3 span {
  font-family: CustomFont3;
  font-size: 26px;
}
@media screen and (max-width: 1950px) {
}
@media screen and (max-width: 1500px) {
  .content-btn {
    line-height: 28px;
    font-size: 16px;
  }
  .selection-area .sel-tab {
    font-size: 15px;
  }
}
@media screen and (max-width: 1200px) {
  .content-btn {
    line-height: 24px;
    font-size: 14px;
  }
  .selection-area .sel-tab {
    font-size: 12px;
		height: 45px;
  }
  .tab-title {
    font-size: 28px;
  }
}
@media screen and (max-width: 1024px) {
  .content-btn {
    line-height: 20px;
    font-size: 12px; /*最小了 ，后面可用缩放*/
  }
  .table-box .table .sel-header {
    font-size: 18px;
  }
  .tab-title {
    font-size: 26px;
  }
}
@media screen and (max-width: 768px) {
  .table .tool-bar {
    margin: 10px auto;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .tool-bar .tool-input {
    padding-bottom: 10rpx;
  }
  .tool-bar /deep/ .el-input__inner {
    padding: 0 10px;
  }
  .content-table {
    width: 95%;
  }
  .selection-area, .table-box .table {
    margin: auto 1%;
  }
  .selection-area .sel-tab {
    margin: auto 2px;
    padding: 0 5px;
    justify-content: center;
  }
  .content-btn {
    line-height: 14px;
  }
  .table-box .table .sel-header {
    font-size: 14px;
  }
  .tab-title {
    font-size: 16px;
    padding-bottom: 5px
  }
  .table .tips-top {
    margin-bottom: 0;
    font-size: 10px;
  }
  .tabs-box /deep/ .el-tabs__item {
    font-size: 12px;
  }
  .caculate-area /deep/ .el-button {
    padding: 8px 10px;
  }
  .caculate-area /deep/ .el-table {
    font-size: 12px;
    overflow: overlay;
  }
  .caculate-area /deep/ .el-table .cell {
    padding-left: 0px!important;
    padding-right: 0px!important;
    /* transform: scale(0.8); */
    line-height: 16px;
  }
  .caculate-area /deep/ .el-table .el-table__placeholder {
    width: 0px!important;
  }
  .caculate-area /deep/ .el-table .el-table__cell {
    text-align: center!important;
    padding: 5px 0;
  }
  .total-table /deep/ .el-table__footer-wrapper {
    position: absolute;
    top: 48px;
    left: 0;
    height: 30px;
  }
  .total-table /deep/ .el-table__body-wrapper {
    margin-top: 28px;
  }
  .dialog-container /deep/ .el-table {
    font-size: 12px;
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .dialog-container /deep/ .el-table .cell {
    padding-left: 0px;
    padding-right: 0px;
    /* transform: scale(0.8); */
    line-height: 16px;
  }
  .dialog-container /deep/ .el-table .el-table__placeholder {
    width: 0px;
  }
  .dialog-container /deep/ .el-table .el-table__cell {
    text-align: center;
    padding: 5px 0;
  }
  .dialog-container /deep/ .el-dialog--center .el-dialog__body {
    padding: 5px 5px 30px;
  }
  .caculate-area /deep/ .el-table [class*=el-table__row--level] .el-table__expand-icon {
    width: 10px;
    margin-left: -10px;
  }
  .caculate-area /deep/ .el-table .el-table__indent {
    padding: 0!important;
  }
  .dialog-container /deep/ .el-table [class*=el-table__row--level] .el-table__expand-icon {
    width: 10px;
    margin-left: -10px;
  }
  .dialog-container /deep/ .el-table .el-table__indent {
    padding: 0!important;
  }
  .tabs-box /deep/ .el-tabs__nav {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .tabs-box-3 /deep/ .el-tabs__item {
    width: 32%;
    text-align: center;
  }
  .tabs-box-2 /deep/ .el-tabs__item {
    width: 48%;
    text-align: center;
  }
  .caculate-area /deep/ .el-table {
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .caculate-area /deep/ .el-table th {
    /* 恢复正常字体大小 */
    font-size: 12px !important;
  }
  .caculate-area /deep/ .el-table th.is-center {
    padding: 10 0;
    margin: 0;
    float: none;
    line-height: 16px;
  }
}
@media screen and (max-width: 550px) {
  .content-table {
    width: 99%;
  }
  .selection-area, .table-box .table {
    margin: auto 0%;
  }
  .selection-area .sel-tab {
    margin: auto 2px;
    padding: 0 4px;
    justify-content: center;
  }
  .content-btn {
    line-height: 12px;
  }
  .poster {
    position: relative;
    width: 500px;
    height: calc(500px * 81 / 54);
    /* height: 810px; */
  }
  .poster-text .text-1 {
    font-size: 20px;
    line-height: 22px;
  }
  .poster-text .text-2 {
    height: 54px;
    line-height: 25px;
    font-size: 20px;
  }
  .poster-text .text-3 {
    font-size: 58px;
    line-height: 68px;
  }
  .poster-text .text-3 span {
    font-size: 24px;
  }
}
@media screen and (max-width: 500px) {
  .poster {
    position: relative;
    width: 450px;
    height: calc(450px * 81 / 54);
    /* height: 810px; */
  }
  .poster-text .text-1 {
    font-size: 16px;
    line-height: 22px;
  }
  .poster-text .text-2 {
    height: 48px;
    line-height: 22px;
    font-size: 18px;
  }
  .poster-text .text-3 {
    font-size: 50px;
    line-height: 68px;
  }
  .poster-text .text-3 span {
    font-size: 24px;
  }

}
@media screen and (max-width: 450px) {
  .poster {
    position: relative;
    width: 400px;
    height: calc(400px * 81 / 54);
    /* height: 810px; */
  }
  .poster-text .text-1 {
    font-size: 14px;
    line-height: 20px;
  }
  .poster-text .text-2 {
    height: 40px;
    line-height: 20px;
    font-size: 16px;
  }
  .poster-text .text-3 {
    font-size: 46px;
    line-height: 50px;
  }
  .poster-text .text-3 span {
    font-size: 24px;
  }

}
@media screen and (max-width: 400px) {
  .poster {
    position: relative;
    width: 350px;
    height: calc(350px * 81 / 54);
    /* height: 810px; */
  }
  .poster-text .text-1 {
    font-size: 12px;
    line-height: 16px;
  }
  .poster-text .text-2 {
    height: 38px;
    line-height: 20px;
    font-size: 15px;
  }
  .poster-text .text-3 {
    font-size: 38px;
    line-height: 48px;
  }
  .poster-text .text-3 span {
    font-size: 24px;
  }
}
@media screen and (max-width: 350px) {
  .poster {
    position: relative;
    width: 300px;
    height: calc(300px * 81 / 54);
    /* height: 810px; */
  }
  .poster-text .text-1 {
    font-size: 12px;
    line-height: 16px;
  }
  .poster-text .text-2 {
    height: 34px;
    line-height: 13px;
    font-size: 12px;
  }
  .poster-text .text-3 {
    font-size: 32px;
    line-height: 36px;
  }
  .poster-text .text-3 span {
    font-size: 24px;
  }
}
@media screen and (max-width: 360px) {
  .el-button {
    padding: 12px 10px!important;
  }
  .table .tool-bar {
    margin: 0px;
  }
  .selection-area .sel-tab {
    margin: 0px;
    padding: 0px;
  }
  .content-btn {
    line-height: 10px;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Special.vue